import React from 'react';
import SubscriptionList from './subscription-list';
import { inject, observer } from 'mobx-react';

class ManageSubscriptions extends React.Component {
    render () {
        const {member, cancelled} = this.props;
        console.log(cancelled);
        return (
            <div data-ta={ cancelled ? 'cancelled-subscriptions' : 'active-subscriptions' }>
                {!cancelled && (<div className="section-title margin-bottom-3">Manage Subscriptions</div>)}
                {cancelled && (<div className="section-title margin-bottom-3">Cancelled Subscriptions</div>)}
                <SubscriptionList cancelled={cancelled} member={member}/>
            </div>
        )
    }
}
export default ManageSubscriptions;